if (!customElements.get('sticky-add-to-cart')) {
  customElements.define('sticky-add-to-cart', class StickyAddToCart extends HTMLElement {
    constructor() {
      super();
      this.sectionId = this.dataset.sectionId;
      this.mainSubmitButton = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
      this.priceWrapper = this.querySelector('[data-sticky-price]');
      this.stickyButton = this.querySelector('[data-sticky-submit]');
      this.mobileQuery = window.matchMedia('(max-width: 749px)');
      this.mainButtonVisible = true;
    }

    connectedCallback() {
      if (!this.mainSubmitButton) return;

      this.observer = new IntersectionObserver((entries) => {
        this.mainButtonVisible = entries[0].isIntersecting;
        this.updateVisibility();
      }, { threshold: 0 });
      this.observer.observe(this.mainSubmitButton);

      this.mobileQueryListener = () => this.updateVisibility();
      if (this.mobileQuery.addEventListener) {
        this.mobileQuery.addEventListener('change', this.mobileQueryListener);
      } else if (this.mobileQuery.addListener) {
        this.mobileQuery.addListener(this.mobileQueryListener);
      }

      if (this.stickyButton) {
        this.stickyButton.addEventListener('click', this.handleClick.bind(this));
      }

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, this.handleVariantChange.bind(this));
      }

      this.updateVisibility();
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      if (this.mobileQuery && this.mobileQueryListener) {
        if (this.mobileQuery.removeEventListener) {
          this.mobileQuery.removeEventListener('change', this.mobileQueryListener);
        } else if (this.mobileQuery.removeListener) {
          this.mobileQuery.removeListener(this.mobileQueryListener);
        }
      }
      if (this.variantChangeUnsubscriber) this.variantChangeUnsubscriber();
    }

    updateVisibility() {
      const shouldShow = this.mobileQuery.matches && !this.mainButtonVisible;
      this.classList.toggle('aovo-sticky-atc--visible', shouldShow);
    }

    handleVariantChange(event) {
      if (!event || !event.data || event.data.sectionId !== this.sectionId) return;

      const updatedPrice = event.data.html.getElementById(`price-${this.sectionId}`);
      if (updatedPrice && this.priceWrapper) {
        this.priceWrapper.innerHTML = updatedPrice.innerHTML;
      }

      const updatedButton = event.data.html.getElementById(`ProductSubmitButton-${this.sectionId}`);
      if (updatedButton && this.stickyButton) {
        this.stickyButton.toggleAttribute('disabled', updatedButton.hasAttribute('disabled'));
      }

      // The main submit button element itself doesn't get replaced on variant change,
      // only its disabled state / label, so our original reference stays valid.
      this.mainSubmitButton = document.getElementById(`ProductSubmitButton-${this.sectionId}`) || this.mainSubmitButton;
    }

    handleClick(event) {
      event.preventDefault();
      if (!this.mainSubmitButton) return;
      if (this.mainSubmitButton.hasAttribute('disabled') || this.mainSubmitButton.getAttribute('aria-disabled') === 'true') {
        return;
      }
      this.mainSubmitButton.click();
    }
  });
}
